import { Reducer } from 'redux';
import IProductTypeState from '../../interfaces/states/product-type';
import ActionTypes from '../../constants/action-types';
import BaseStateDefault from '../../constants/state';

const initialState: IProductTypeState = { ...BaseStateDefault };

const reducer: Reducer<any> = (state: IProductTypeState = initialState, action): IProductTypeState => {
  switch (action.type) {
    case ActionTypes.productType.PRODUCT_TYPE_GET_LIST_REQUEST: {
      return {
        ...state,
        requesting: true,
        error: undefined,
      };
    }
    case ActionTypes.productType.PRODUCT_TYPE_GET_LIST_FAILURE: {
      return {
        ...state,
        requesting: false,
        error: action.payload,
      };
    }
    case ActionTypes.productType.PRODUCT_TYPE_GET_LIST_SUCCESS: {
      return {
        ...state,
        requesting: false,
        list: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
